"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.isHasArrFilters = exports.getTranslation = exports.getConfigFilterByTab = exports.getArrFilters = exports.default = void 0;
var _set = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/set"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
require("core-js/modules/es6.regexp.split.js");
require("core-js/modules/es6.regexp.match.js");
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.array.map.js");
var _filter = require("@nucleo/filter");
var _size = _interopRequireDefault(require("lodash/size"));
function cov_1enamab9we() {
  var path = "/codebuild/output/src1689451169/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/productList/lib/helper.js";
  var hash = "4171a74e14ba7d52087c9c536ff2e0b1e4574eb1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1689451169/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/productList/lib/helper.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 11
        },
        end: {
          line: 4,
          column: 33
        }
      },
      "1": {
        start: {
          line: 5,
          column: 12
        },
        end: {
          line: 5,
          column: 26
        }
      },
      "2": {
        start: {
          line: 6,
          column: 14
        },
        end: {
          line: 6,
          column: 30
        }
      },
      "3": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 20
        }
      },
      "4": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 33
        }
      },
      "5": {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 17,
          column: 39
        }
      },
      "6": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 13
        }
      },
      "7": {
        start: {
          line: 24,
          column: 12
        },
        end: {
          line: 24,
          column: 48
        }
      },
      "8": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 25,
          column: 26
        }
      },
      "9": {
        start: {
          line: 25,
          column: 9
        },
        end: {
          line: 25,
          column: 26
        }
      },
      "10": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 26,
          column: 13
        }
      },
      "11": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 45,
          column: 3
        }
      },
      "12": {
        start: {
          line: 31,
          column: 14
        },
        end: {
          line: 31,
          column: 42
        }
      },
      "13": {
        start: {
          line: 32,
          column: 20
        },
        end: {
          line: 32,
          column: 24
        }
      },
      "14": {
        start: {
          line: 33,
          column: 18
        },
        end: {
          line: 33,
          column: 33
        }
      },
      "15": {
        start: {
          line: 34,
          column: 22
        },
        end: {
          line: 34,
          column: 40
        }
      },
      "16": {
        start: {
          line: 35,
          column: 16
        },
        end: {
          line: 35,
          column: 41
        }
      },
      "17": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 18
        }
      },
      "18": {
        start: {
          line: 39,
          column: 15
        },
        end: {
          line: 39,
          column: 46
        }
      },
      "19": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 28
        }
      },
      "20": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 23
        }
      },
      "21": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 16
        }
      },
      "22": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 16
        }
      },
      "23": {
        start: {
          line: 48,
          column: 24
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "24": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 49,
          column: 31
        }
      },
      "25": {
        start: {
          line: 49,
          column: 19
        },
        end: {
          line: 49,
          column: 31
        }
      },
      "26": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 55,
          column: 26
        }
      },
      "27": {
        start: {
          line: 60,
          column: 29
        },
        end: {
          line: 70,
          column: 1
        }
      },
      "28": {
        start: {
          line: 61,
          column: 24
        },
        end: {
          line: 61,
          column: 34
        }
      },
      "29": {
        start: {
          line: 62,
          column: 2
        },
        end: {
          line: 64,
          column: 3
        }
      },
      "30": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 42
        }
      },
      "31": {
        start: {
          line: 65,
          column: 2
        },
        end: {
          line: 67,
          column: 3
        }
      },
      "32": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 50
        }
      },
      "33": {
        start: {
          line: 69,
          column: 2
        },
        end: {
          line: 69,
          column: 37
        }
      },
      "34": {
        start: {
          line: 72,
          column: 36
        },
        end: {
          line: 78,
          column: 1
        }
      },
      "35": {
        start: {
          line: 73,
          column: 22
        },
        end: {
          line: 73,
          column: 24
        }
      },
      "36": {
        start: {
          line: 74,
          column: 2
        },
        end: {
          line: 76,
          column: 4
        }
      },
      "37": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 108
        }
      },
      "38": {
        start: {
          line: 77,
          column: 2
        },
        end: {
          line: 77,
          column: 21
        }
      },
      "39": {
        start: {
          line: 80,
          column: 31
        },
        end: {
          line: 81,
          column: 76
        }
      },
      "40": {
        start: {
          line: 80,
          column: 43
        },
        end: {
          line: 81,
          column: 76
        }
      },
      "41": {
        start: {
          line: 81,
          column: 57
        },
        end: {
          line: 81,
          column: 75
        }
      },
      "42": {
        start: {
          line: 83,
          column: 30
        },
        end: {
          line: 84,
          column: 100
        }
      },
      "43": {
        start: {
          line: 83,
          column: 82
        },
        end: {
          line: 84,
          column: 100
        }
      }
    },
    fnMap: {
      "0": {
        name: "hasRel",
        decl: {
          start: {
            line: 8,
            column: 9
          },
          end: {
            line: 8,
            column: 15
          }
        },
        loc: {
          start: {
            line: 8,
            column: 19
          },
          end: {
            line: 10,
            column: 1
          }
        },
        line: 8
      },
      "1": {
        name: "intoRels",
        decl: {
          start: {
            line: 12,
            column: 9
          },
          end: {
            line: 12,
            column: 17
          }
        },
        loc: {
          start: {
            line: 12,
            column: 26
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 12
      },
      "2": {
        name: "splitRel",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 19
          }
        },
        loc: {
          start: {
            line: 13,
            column: 25
          },
          end: {
            line: 15,
            column: 3
          }
        },
        line: 13
      },
      "3": {
        name: "createObjects",
        decl: {
          start: {
            line: 22,
            column: 9
          },
          end: {
            line: 22,
            column: 22
          }
        },
        loc: {
          start: {
            line: 22,
            column: 31
          },
          end: {
            line: 27,
            column: 1
          }
        },
        line: 22
      },
      "4": {
        name: "parseLink",
        decl: {
          start: {
            line: 29,
            column: 9
          },
          end: {
            line: 29,
            column: 18
          }
        },
        loc: {
          start: {
            line: 29,
            column: 25
          },
          end: {
            line: 46,
            column: 1
          }
        },
        line: 29
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 48,
            column: 24
          },
          end: {
            line: 48,
            column: 25
          }
        },
        loc: {
          start: {
            line: 48,
            column: 38
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 48
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 60,
            column: 29
          },
          end: {
            line: 60,
            column: 30
          }
        },
        loc: {
          start: {
            line: 60,
            column: 95
          },
          end: {
            line: 70,
            column: 1
          }
        },
        line: 60
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 72,
            column: 36
          },
          end: {
            line: 72,
            column: 37
          }
        },
        loc: {
          start: {
            line: 72,
            column: 105
          },
          end: {
            line: 78,
            column: 1
          }
        },
        line: 72
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 74,
            column: 19
          },
          end: {
            line: 74,
            column: 20
          }
        },
        loc: {
          start: {
            line: 74,
            column: 26
          },
          end: {
            line: 76,
            column: 3
          }
        },
        line: 74
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 80,
            column: 31
          },
          end: {
            line: 80,
            column: 32
          }
        },
        loc: {
          start: {
            line: 80,
            column: 43
          },
          end: {
            line: 81,
            column: 76
          }
        },
        line: 80
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 81,
            column: 46
          },
          end: {
            line: 81,
            column: 47
          }
        },
        loc: {
          start: {
            line: 81,
            column: 57
          },
          end: {
            line: 81,
            column: 75
          }
        },
        line: 81
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 83,
            column: 30
          },
          end: {
            line: 83,
            column: 31
          }
        },
        loc: {
          start: {
            line: 83,
            column: 82
          },
          end: {
            line: 84,
            column: 100
          }
        },
        line: 83
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 9
          },
          end: {
            line: 9,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 9
          },
          end: {
            line: 9,
            column: 10
          }
        }, {
          start: {
            line: 9,
            column: 14
          },
          end: {
            line: 9,
            column: 19
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 26
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 25
      },
      "2": {
        loc: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 49,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 49,
            column: 31
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 49
      },
      "3": {
        loc: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 64,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 64,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 62
      },
      "4": {
        loc: {
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 67,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 67,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 65
      },
      "5": {
        loc: {
          start: {
            line: 72,
            column: 37
          },
          end: {
            line: 72,
            column: 50
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 72,
            column: 48
          },
          end: {
            line: 72,
            column: 50
          }
        }],
        line: 72
      },
      "6": {
        loc: {
          start: {
            line: 80,
            column: 43
          },
          end: {
            line: 81,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 43
          },
          end: {
            line: 80,
            column: 61
          }
        }, {
          start: {
            line: 81,
            column: 5
          },
          end: {
            line: 81,
            column: 28
          }
        }, {
          start: {
            line: 81,
            column: 32
          },
          end: {
            line: 81,
            column: 76
          }
        }],
        line: 80
      },
      "7": {
        loc: {
          start: {
            line: 83,
            column: 82
          },
          end: {
            line: 84,
            column: 100
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 82
          },
          end: {
            line: 83,
            column: 94
          }
        }, {
          start: {
            line: 84,
            column: 3
          },
          end: {
            line: 84,
            column: 32
          }
        }, {
          start: {
            line: 84,
            column: 36
          },
          end: {
            line: 84,
            column: 65
          }
        }, {
          start: {
            line: 84,
            column: 69
          },
          end: {
            line: 84,
            column: 99
          }
        }],
        line: 83
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0],
      "6": [0, 0, 0],
      "7": [0, 0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4171a74e14ba7d52087c9c536ff2e0b1e4574eb1"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1enamab9we = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1enamab9we();
var qs = (cov_1enamab9we().s[0]++, require('querystring'));
var url = (cov_1enamab9we().s[1]++, require('url'));
var xtend = (cov_1enamab9we().s[2]++, require('xtend'));
function hasRel(x) {
  cov_1enamab9we().f[0]++;
  cov_1enamab9we().s[3]++;
  return (cov_1enamab9we().b[0][0]++, x) && (cov_1enamab9we().b[0][1]++, x.rel);
}
function intoRels(acc, x) {
  cov_1enamab9we().f[1]++;
  function splitRel(rel) {
    cov_1enamab9we().f[2]++;
    cov_1enamab9we().s[4]++;
    acc[rel] = xtend(x, {
      rel: rel
    });
  }
  cov_1enamab9we().s[5]++;
  x.rel.split(/\s+/).forEach(splitRel);
  cov_1enamab9we().s[6]++;
  return acc;
}
function createObjects(acc, p) {
  cov_1enamab9we().f[3]++;
  // rel="next" => 1: rel 2: next
  var m = (cov_1enamab9we().s[7]++, p.match(/\s*(.+)\s*=\s*"?([^"]+)"?/));
  cov_1enamab9we().s[8]++;
  if (m) {
    cov_1enamab9we().b[1][0]++;
    cov_1enamab9we().s[9]++;
    acc[m[1]] = m[2];
  } else {
    cov_1enamab9we().b[1][1]++;
  }
  cov_1enamab9we().s[10]++;
  return acc;
}
function parseLink(link) {
  cov_1enamab9we().f[4]++;
  cov_1enamab9we().s[11]++;
  try {
    var m = (cov_1enamab9we().s[12]++, link.match(/<?([^>]*)>(.*)/));
    var linkUrl = (cov_1enamab9we().s[13]++, m[1]);
    var parts = (cov_1enamab9we().s[14]++, m[2].split(';'));
    var parsedUrl = (cov_1enamab9we().s[15]++, url.parse(linkUrl));
    var qry = (cov_1enamab9we().s[16]++, qs.parse(parsedUrl.query));
    cov_1enamab9we().s[17]++;
    parts.shift();
    var info = (cov_1enamab9we().s[18]++, parts.reduce(createObjects, {}));
    cov_1enamab9we().s[19]++;
    info = xtend(qry, info);
    cov_1enamab9we().s[20]++;
    info.url = linkUrl;
    cov_1enamab9we().s[21]++;
    return info;
  } catch (e) {
    cov_1enamab9we().s[22]++;
    return null;
  }
}
cov_1enamab9we().s[23]++;
var parseLinkHeader = function parseLinkHeader(linkHeader) {
  cov_1enamab9we().f[5]++;
  cov_1enamab9we().s[24]++;
  if (!linkHeader) {
    cov_1enamab9we().b[2][0]++;
    cov_1enamab9we().s[25]++;
    return null;
  } else {
    cov_1enamab9we().b[2][1]++;
  }
  cov_1enamab9we().s[26]++;
  return linkHeader.split(/,\s*</).map(parseLink).filter(hasRel).reduce(intoRels, {});
};
var _default = exports.default = parseLinkHeader;
cov_1enamab9we().s[27]++;
var getArrFilters = exports.getArrFilters = function getArrFilters(arrFilters, isPriceFilterEnabled, isProductTypeFilterEnabled) {
  cov_1enamab9we().f[6]++;
  var resultFilters = (cov_1enamab9we().s[28]++, arrFilters);
  cov_1enamab9we().s[29]++;
  if (isPriceFilterEnabled) {
    cov_1enamab9we().b[3][0]++;
    cov_1enamab9we().s[30]++;
    resultFilters.push(_filter.FilterField.PRICE);
  } else {
    cov_1enamab9we().b[3][1]++;
  }
  cov_1enamab9we().s[31]++;
  if (isProductTypeFilterEnabled) {
    cov_1enamab9we().b[4][0]++;
    cov_1enamab9we().s[32]++;
    resultFilters.push(_filter.FilterField.PRODUCT_TYPES);
  } else {
    cov_1enamab9we().b[4][1]++;
  }
  // Remove duplicate filters
  cov_1enamab9we().s[33]++;
  return (0, _toConsumableArray2.default)(new _set.default(resultFilters));
};
cov_1enamab9we().s[34]++;
var getConfigFilterByTab = exports.getConfigFilterByTab = function getConfigFilterByTab() {
  var tabDatas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1enamab9we().b[5][0]++, []);
  var isPriceFilterEnabled = arguments.length > 1 ? arguments[1] : undefined;
  var isProductTypeFilterEnabled = arguments.length > 2 ? arguments[2] : undefined;
  cov_1enamab9we().f[7]++;
  var filterByTab = (cov_1enamab9we().s[35]++, {});
  cov_1enamab9we().s[36]++;
  tabDatas.forEach(function (tab) {
    cov_1enamab9we().f[8]++;
    cov_1enamab9we().s[37]++;
    filterByTab[tab.code] = getArrFilters(tab.arrFilters, isPriceFilterEnabled, isProductTypeFilterEnabled);
  });
  cov_1enamab9we().s[38]++;
  return filterByTab;
};
cov_1enamab9we().s[39]++;
var isHasArrFilters = exports.isHasArrFilters = function isHasArrFilters(tabDatas) {
  cov_1enamab9we().f[9]++;
  cov_1enamab9we().s[40]++;
  return (cov_1enamab9we().b[6][0]++, (0, _size.default)(tabDatas) > 0) && (cov_1enamab9we().b[6][1]++, (0, _isArray.default)(tabDatas)) && (cov_1enamab9we().b[6][2]++, tabDatas.some(function (tabData) {
    cov_1enamab9we().f[10]++;
    cov_1enamab9we().s[41]++;
    return tabData.arrFilters;
  }));
};
cov_1enamab9we().s[42]++;
var getTranslation = exports.getTranslation = function getTranslation(externalName, currentLanguage, defaultLanguage) {
  cov_1enamab9we().f[11]++;
  cov_1enamab9we().s[43]++;
  return (cov_1enamab9we().b[7][0]++, externalName) && ((cov_1enamab9we().b[7][1]++, externalName[currentLanguage]) || (cov_1enamab9we().b[7][2]++, externalName[defaultLanguage]) || (cov_1enamab9we().b[7][3]++, (0, _values.default)(externalName)[0]));
};